import { render, staticRenderFns } from "./MungBeanAllocateSedimentList.vue?vue&type=template&id=40d6ed10&scoped=true&lang=pug&"
import script from "./MungBeanAllocateSedimentList.vue?vue&type=script&lang=ts&"
export * from "./MungBeanAllocateSedimentList.vue?vue&type=script&lang=ts&"
import style0 from "./MungBeanAllocateSedimentList.vue?vue&type=style&index=0&id=40d6ed10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d6ed10",
  null
  
)

export default component.exports